module.exports = __webpack_public_path__ + "static/media/SAP-Ariba-logo-vierkant.903cb29f.png";